<template>
    <div class="downloadContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>视频号下载</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 扫码 -->
        <div class="downloadBox column">
            <el-image :src="require('@/assets/image/download01.png')" fit="cover" class="dlTop"></el-image>
            <div class="dlText">第<span class="dlNum">1</span>步：扫码下方二维码，添加<span>客服机器人</span>微信。</div>
            <el-image :src="downloadCode" fit="cover" class="dlCode"></el-image>
            <div class="dlText">第<span class="dlNum">2</span>步：打开视频号，点击下方的分享按钮。<span>发送给客服机器人</span></div>
            <el-image :src="require('@/assets/image/download02.png')" fit="cover" class="dlImg"></el-image>
            <div class="dlText">第<span class="dlNum">3</span>步：点击<span>客服机器人</span>返回的消息进入下载页面，保存相册，完成</div>
            <el-image :src="require('@/assets/image/download03.png')" fit="cover" class="dlImg"></el-image>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                downloadCode: ''
            }
        },
        mounted(){
            this.getdownload()
        },
        methods: {
           // 获取二维码
           getdownload(){
                this.request.get("index/gongneng/detail",{
                    params:{
                       type: 3
                    }
                })
                .then(res=>{
                    this.downloadCode = res.data
                })
            }, 
        }
    }
</script>
<style lang="less" scoped>
    @import '../../common/css/download.less';
</style>